import connection from '@/api/connection'

export const locationsByProduct = async ({ commit }, product) => {
  commit('setLocationProductIsLoading', true);
  await connection.post(`/locations/product`, product)
    .then(res => {
      commit('setLocationsProduct', res.data.data);
      commit('setLocationProductIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setLocationProductIsLoading', false);
    });
}

export const getLocations = async ({ commit }) => {
  let url = `/locations/selectable`;

  await connection.get(url)
    .then(res => {
      const locations = res.data.data;
      commit('setLocationsSelectable', locations);
    }).catch(err => {
      console.log('error', err);
    });
}

export const locationById = async ({ commit }, id) => {
  commit('setLocationIsLoading', true);
  await connection.get(`/locations/${id}`)
    .then(res => {
      commit('setLocationDetail', res.data.data);
      commit('setLocationIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setLocationIsLoading', false);
    });
}

export const storeLocation = async ({ commit }, location) => {
  commit('setLocationIsCreating', true);
  await connection.post(`/locations/create`, location)
    .then(res => {
      commit('saveNewLocations', res.data);
      commit('setLocationIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setLocationIsCreating', false);
    });
}

export const updateLocation = async ({ commit }, location ) => {
  commit('setLocationIsUpdating', true);
  await connection.put(`/locations/${location.id}/update`, location)
    .then(res => {
      commit('saveUpdatedLocation', res.data);
      commit('setLocationIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setLocationIsUpdating', false);
    });
}

export const deleteLocation = async ({ commit }, location) => {
  commit('setLocationIsDeleting', true);
  await connection.delete(`/locations/${location.id}/delete`)
    .then(res => {
      commit('setDeleteLocation', res.data);
      commit('setLocationIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setLocationIsDeleting', false);
    });
}

export const updateStockUnoutput = async ({ commit }, location ) => {
  commit('setLocationIsUpdating', true);
  await connection.put(`/locations/${location.id}/update/stockunoutput`, location)
    .then(res => {
      console.log(res.data.data);
      console.log(res.data);
      commit('saveUpdatedLocation', res.data);
      commit('setLocationIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setLocationIsUpdating', false);
    });
}